export default "__VITE_ASSET__BOEvJ9Dl__"